import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { CircularProgress } from '../../../common'

import OfflineModeHeader from '../../../containers/OfflineModeHeader'
import MenuHeader from '../../../containers/MenuHeader'
import SettingsTable from '../../../containers/SettingsTable'
import EditEmailModal from '../../../containers/EditEmailModal'
import EditPasswordModal from '../../../containers/EditPasswordModal'
import DeleteAccountModal from '../../../containers/DeleteAccountModal'

import * as Constants from '../../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'
import * as feedActions from '../../../../actions/Feed'
import * as offlineModeActions from '../../../../actions/OfflineMode'

class MyPage extends Component {
  componentWillMount() {
    const { history, user, offlineMode } = this.props

    if (offlineMode) {
      if (!user.offlineModeSignedIn) {
        this.props.setOfflineSetup()
      }
    } else if (!user.fetched) {
      history.push('/')
    }
  }

  renderContent() {
    const { user, history, offlineMode } = this.props

    if (!user.fetched && !offlineMode) {
      history.push('/')
    }

    if (!user.fetched) {
      return <CircularProgress />
    }

    return (
      <div style={Styles.default.container}>
        <div
          style={{
            ...Styles.default.innerContainer,
            marginTop: offlineMode ? 60 : 20
          }}
        >
          <SettingsTable />
          <EditEmailModal />
          <EditPasswordModal />
          <DeleteAccountModal history={history} />
        </div>
      </div>
    )
  }

  render() {
    const { config, history } = this.props

    return (
      <MenuHeader
        history={history}
        header={Strings.default.MY_PAGE[config.language]}
        selected={Constants.MY_PAGE_FOCUSED}
      >
        <OfflineModeHeader history={history} />
        {this.renderContent()}
      </MenuHeader>
    )
  }
}

function mapStateToProps({ user, feed, config }) {
  return { user, feed, config }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...offlineModeActions, ...feedActions }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyPage)



// WEBPACK FOOTER //
// ./src/components/pages/generalSettings/MyPage/index.js